import { getNestedString, useConfig } from '@/utils/useConfig';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Button } from '@mui/material';

/**
 * This component handles the Google Authorisation logic.
 * It generates the Google OAuth 2.0 authorization URL and redirects the user to it.
 * It also handles the response from Google after the user has authorized the application.
 * @returns A button that redirects to the Google OAuth 2.0 authorization URL.
 */
function GoogleAuth({ disabled, intent = 'sign-in' }: Readonly<{ disabled?: boolean; intent?: string; }>) {

	const { config, loading: _loading, error: _error, refresh: _refresh, isStale: _isStale } = useConfig('auth_pages_config');

	const redirectUri = encodeURIComponent(`${globalThis.window.location.origin}/${intent === 'sign-up' ? 'sign-up' : 'sign-in'}`);

	const scope = 'email+profile+openid+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&hd=dns.business&prompt=select_account';

	/**
	 * Google OAuth 2.0 authorization URL
	 */
	const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${getNestedString(config, 'google.clientId')}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}`;

	return <Button
		variant="outlined"
		className="flex-auto"
		href={authUrl}
		disabled={disabled}
	>
		<FuseSvgIcon
			size={12}
			color="action"
			className='mr-5'
		>
			feather:google
		</FuseSvgIcon>
		Google
	</Button>;

}

export default GoogleAuth;
